import { FC, useContext } from "react";
import { Context } from "../../../..";
import UserPopupWrapper from "../../UserPopup/UserPopupWrapper";
import Avatar, { AvatarSize } from "../../Avatar/Avatar";
import QuillPreview from "../../TextEditor/QuillPreview/QuillPreview";
import MessageHeader from "./MessageHeader";
import MessageHistory from "./MessageHistory";
import MessageActions from "./MessageActions";
import { IMessage } from "../../../../common/api_interfaces/chat/IMessage";

interface MessageItemProps {
    message: IMessage;
    isOwnMessage: boolean;
    style: React.CSSProperties;
    onCopyUrl: (id: number) => void;
    onEdit: (message: IMessage) => void;
    onDelete: (id: number) => void;
    canDelete: boolean;
    showToast: (message: string) => void;
}

const MessageItem: FC<MessageItemProps> = ({
    message,
    isOwnMessage,
    style,
    onCopyUrl,
    onEdit,
    onDelete,
    canDelete,
    showToast
}) => {
    const { store } = useContext(Context);
    
    return (
        <div
            id={`message-${message.id}`}
            className={isOwnMessage 
                ? "input--chat__block--messages__message--block__right" 
                : "input--chat__block--messages__message--block__left"
            }
        >
            <div
                className={isOwnMessage 
                    ? "input--chat__block--messages__message--block__flex--right" 
                    : "input--chat__block--messages__message--block__flex--left"
                }
                style={style}
            >
                <UserPopupWrapper userId={message.createdBy.id} style={{ alignItems: "flex-start" }}>
                    <div style={{ cursor: "pointer" }}>
                        <Avatar userId={message.createdBy.id} size={AvatarSize.m} />
                    </div>
                </UserPopupWrapper>
                
                <div className="input--chat__block--messages__message">
                    <MessageHeader
                        message={message} 
                        onCopyUrl={onCopyUrl} 
                    />
                    
                    {message.projectLogs && message.projectLogs?.length > 0 && (
                        <MessageHistory projectLogs={message.projectLogs} />
                    )}
                    
                    {message.text.length > 0 && (
                        <div className="input--chat__block--messages__message--text">
                            <QuillPreview htmlContent={message.text} />
                        </div>
                    )}
                    
                    {isOwnMessage && message.deletable && (
                        <MessageActions
                            message={message}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            canDelete={canDelete}
                            showToast={showToast}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default MessageItem;